import React, { useEffect } from 'react';

// hooks
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown';

// helpers
import requestSSOAuthToken from 'src/dataLayer/remoteData/babbelAPI/requestSSOAuthToken';
import { postMessage } from 'src/viewLayer/helpers/safeNativeReporter';

// components
import Loader from 'src/viewLayer/components/shared/Loader';
import './SuccessCallbackPage.scss';

export default function SuccessCallbackPage({ appType, path }) {
  useTrackPageShown({ appType, pageType: 'b2b_sso_' + (path || 'success') });

  useEffect(() => {
    requestSSOAuthToken().then(({ authenticationToken }) => postMessage(authenticationToken));
  }, []);

  return (<Loader />);
}
